export function getAccessToken() {
  return localStorage.getItem("accessToken");
}

export function getRefreshToken() {
  return localStorage.getItem("refreshToken");
}

export function setAccessToken(token: string) {
  return localStorage.setItem("accessToken", token);
}

export function setRefreshToken(token: string) {
  return localStorage.setItem("refreshToken", token);
}

export function clearToken() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
}
